import { AccountErrorType, OrderEntryIssueTypeDomestic } from '../../../../enums';

export interface IOrderEntrySubtypeDom {
    issueType: OrderEntryIssueTypeDomestic;
    csrGID?: string;
    accountErrorType?: AccountErrorType[];
    orderTypeIncorrectlyUsed?: string;
    correctOrderType?: string;
}
